import { useHistory } from "react-router-dom";
import { navigateToMappingTestEditor } from "../../../router/RouterUtils";
import { useState } from "react";
import DropdownFormField from "../../blueprint-editor/right-panel/DropdownFormField";
import { createMappingTestCase } from "../../mapping-tests/utils/MappingTestFetchUtils";
import { showErrorToast } from "../../shared/Toasts";
import { MappingTestExpectedResult, MappingTestMeta } from "../../../models/MappingTests";
import InputFormField from "../../blueprint-editor/right-panel/InputFormField";
import { getReadableNameForExpectedResult } from "../../mapping-tests/utils/MappingTestBuildingUtils";
import { ButtonVariant, Dialog } from "@merge-api/merge-javascript-shared";

type Props = {
  categories: Array<string>;
  endpointCollectionID: string;
  integrationID: string;
  isShown: boolean;
  onHide: () => void;
};

const CreateMappingTestCaseModal = ({
  integrationID,
  endpointCollectionID,
  isShown,
  onHide,
}: Props) => {
  const [name, setName] = useState<string>("");
  const [expectedResult, setExpectedResult] = useState<MappingTestExpectedResult>(
    MappingTestExpectedResult.SUCCESS
  );

  const history = useHistory();

  const addMappingTest = () => {
    createMappingTestCase({
      endpointCollectionID,
      expectedResult,
      name,
      onResponse: (data: MappingTestMeta) =>
        navigateToMappingTestEditor(history, integrationID, data.id),
      onError: () => showErrorToast("Failed to create test"),
    });
  };

  return (
    <Dialog
      open={isShown}
      onClose={onHide}
      title="Create test"
      primaryButtonText="Create test case"
      onPrimaryButtonClick={addMappingTest}
      primaryButtonVariant={ButtonVariant.PrimaryGray}
      primaryButtonDisabled={!name}
      secondaryButtonText="Cancel"
      onSecondaryButtonClick={onHide}
      secondaryButtonVariant={ButtonVariant.TextBlack}
    >
      <InputFormField
        title="Name"
        subtitle="The name of the test."
        placeholder="Test name"
        onChange={(name) => setName(name)}
        currentValue={name}
      />
      <DropdownFormField
        title="Expected result"
        subtitle="The expected result of the test"
        placeholder="Select expected result"
        onChange={(e) => setExpectedResult(e.target.value)}
        currentValue={expectedResult}
        choices={Object.values(MappingTestExpectedResult).map((expectedResult) => ({
          name: getReadableNameForExpectedResult(expectedResult),
          id: expectedResult,
        }))}
      />
    </Dialog>
  );
};

export default CreateMappingTestCaseModal;
